




















































































































































import { SvgImage } from '@/app/components';
import { useSockets } from '@/app/composable/socket';
// import { StatusCode } from '@/modules/asset/constants';
import {
    DownloadIcon,
    HomeIcon,
    SearchIcon,
    XIcon,
    BookOpenIcon,
    UserIcon,
    ChevronDoubleUpIcon,
    ChevronDoubleDownIcon,
    CreditCardIcon,
    CollectionIcon,
    DocumentDuplicateIcon,
} from '@vue-hero-icons/outline';
import { computed, defineComponent } from '@vue/composition-api';
import { useFeatureFlags } from '../composable';
import store from '@/app/store';
import { UserRoles } from '../constants';

export default defineComponent({
    name: 'SideMenu',
    components: {
        HomeIcon,
        SearchIcon,
        XIcon,
        SvgImage,
        BookOpenIcon,
        DownloadIcon,
        UserIcon,
        ChevronDoubleDownIcon,
        CreditCardIcon,
        CollectionIcon,
        DocumentDuplicateIcon,
    },
    props: {
        mobileMenuOpen: { type: Boolean, default: false },
    },
    setup(props, { root }) {
        const { isEnabled: isFeatureEnabled, areAnyEnabled: areAnyFeaturesEnabled } = useFeatureFlags();
        const { connected, socketConnect } = useSockets();
        // const defaultAssetStatus = Object.values(StatusCode).filter(
        //     (statusCode: StatusCode) => ![StatusCode.Deleted, StatusCode.Archived].includes(statusCode),
        // );

        const isAdmin = computed(() => store.getters.auth.hasRole(UserRoles.Admin));

        type NavigationItem = {
            name: string;
            route: string;
            icon: any;
            query?: Record<string, any>;
            exact: Boolean;
            visible: Boolean;
        };

        const sidebarNavigation = computed(() => [
            {
                name: 'Collections',
                route: 'data-checkin-jobs',
                icon: ChevronDoubleUpIcon,
                exact: false,
                visible: true,
            },
            {
                name: 'Datasets',
                route: 'assets',
                // query: { status: defaultAssetStatus.join(','), reset: true },
                icon: DocumentDuplicateIcon,
                exact: false,
                visible: true,
            },
            {
                name: 'Data Market',
                route: 'marketplace',
                icon: CreditCardIcon,
                exact: true,
                visible: isFeatureEnabled('sharing'),
            },
            {
                name: 'Data Contracts',
                route: 'contracts',
                icon: CollectionIcon,
                exact: true,
                visible: isFeatureEnabled('sharing'),
            },
            {
                name: 'Retrievals',
                route: 'retrieval',
                icon: ChevronDoubleDownIcon,
                exact: false,
                visible: areAnyFeaturesEnabled(['retrieve.api', 'retrieve.files', 'retrieve.stream']),
            },
            {
                name: 'Models',
                route: 'model-manager',
                icon: BookOpenIcon,
                exact: false,
                visible: isAdmin.value,
            },
            {
                name: 'Admin Portal',
                route: 'admin-portal',
                icon: UserIcon,
                exact: false,
                visible: isAdmin.value,
            },
        ]);

        const isSidebarItemActive = (item: NavigationItem) => {
            return root.$route.name === item.route;
        };

        return { sidebarNavigation, connected, socketConnect, isSidebarItemActive };
    },
});
